var map = {
	"./amit.webp": 3895,
	"./bon.webp": 3399,
	"./ced.webp": 1120,
	"./dave.webp": 2038,
	"./david.webp": 3442,
	"./fatima.webp": 5748,
	"./fred.webp": 2341,
	"./gab.webp": 1942,
	"./jenna.webp": 9200,
	"./jerry.webp": 8592,
	"./jorrel.webp": 1662,
	"./ken.webp": 9090,
	"./magic.webp": 4723,
	"./pauline.webp": 5152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9898;